import { render, staticRenderFns } from "./BaseTableReportHistoryListing.vue?vue&type=template&id=3ae5fe1f"
import script from "./BaseTableReportHistoryListing.vue?vue&type=script&lang=js"
export * from "./BaseTableReportHistoryListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports